// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"a4154000","24":"ee73e5a6","838":"a4154000"}[chunkId] + ".chunk.css";
};